import React from "react";
import Logo from "../../../assets/images/logo/jsa hospital.jpeg";



const Jmsh = React.forwardRef((props, ref) => {
  return (
    <>
      <div className="row container align-items-center mx-0 mt-4" ref={ref}>
        <div className="col-md-4">
          <img src={Logo} alt="jsacat" width="100%" className="rounded" />
        </div>
        <div className="col-md-8 text-justify">
          <h4 className="text-success my-3 fw-bolder">
           JSA Multi-Speciality Hospitals
          </h4>
          <p className="text-justify fw-bold">
           JSA Multi Specialty Hospitals is acclaimed for pioneering the private healthcare revolution in the country. JSA Multi Specialty Hospitals has emerging integrated healthcare service provided for the needy peoples and a robust presence across the healthcare ecosystem, including Hospitals, Pharmacies, Primary Care & Diagnostic Clinics and several retail health models. Health Insurance Services, Global Projects Consultancy, Medical Colleges, Medvarsity for E-Learning, Colleges of Nursing and Hospitals Management and a Research Foundation.
          </p>
          <p className="text-justify">
             At JSA Multi Specialty Hospitals, we are dedicated to delivering excellence in healthcare through a blend of advanced Medical Technology, highly skilled specialties, and compassionate patient care. With comprehensive services under one roof, from preventive health check-ups to complex surgeries and critical care.
          </p>
          <p className="text-justify">
            We ensure holistic treatment is tailored to every individual’s needs. Our state-of-the-art infrastructure, round-the-clock emergency support and patient-centered approach make us a trusted healthcare destination. Guided by a commitment to safety, affordability and quality, we strive to provide not just treatment, but a healing experience that prioritizes your well-being at every step.
          </p>
          <p>
            We provide timely, reliable and compassionate treatment guided by expertise and a commitment to your care. We are committed to the achievement and maintenance of excellence in education, research and healthcare for the benefit of humidity”
          </p>
          <p>
            Likewise, envisioned to keep Indians peoples healthy. JSA Multi Specialty Hospitals championed numerous social initiatives – to cite a few which assist underprivileged children, to introduce population health into the Indian narrative, It aims to provide ”holistic healthcare” for the entire community starting from birth, through one’s journey into childhood, adolescence, adulthood and old age.
          </p>
          <div className="row text-secondary">
            <h6 className="text-dark mb-3">Our Facilities</h6>
            <div className="col-sm-6">
              <ul>
                <li>Out patient Ward</li>
                <li>In patient Ward</li>
                <li>Operations Theatre</li>
              </ul>
            </div>
            <div className="col-sm-6">
              <ul>
                <li>Lab</li>
                <li>XRay</li>
                <li>ICU</li>
              </ul>
            </div>
          </div>
          <div className="my-2">
            <a href="https://jsamsh.com/" target="_blank" rel="noreferrer">
              <button className="btn btn-primary">Read More...</button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
});

export default Jmsh;
